import { Select } from '@/components/ui/select'
import { DateRangePicker } from '@/components/ui/date-range-picker'
import type { DashboardFilterParams } from '@/types/api'
import { fetchUnits } from '@/api/units.api'
import {
  formatEndDate,
  formatStartDate,
  parseToLocalDate,
} from '@/utils/format'

interface Props {
  value: DashboardFilterParams
  onChange: (val: DashboardFilterParams) => void
  showUnitColumn: boolean
}

export function DashboardFilterBar({ value, onChange, showUnitColumn }: Props) {
  const getStartOfDayISOString = (date?: Date) => {
    if (!date) {
      return undefined
    }

    const normalized = new Date(date)
    return formatStartDate(normalized) || undefined
  }

  const getEndOfDayISOString = (date?: Date) => {
    if (!date) {
      return undefined
    }
    const normalized = new Date(date)
    return formatEndDate(normalized) || undefined
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      {showUnitColumn ? (
        <Select
          cacheKey="dashboard-filter-unit-select"
          initialPage={0}
          lazy
          placeholder="Tất cả đơn vị"
          value={value.unitId ?? undefined}
          className="w-full sm:w-80 h-10"
          enableRemoteSearch
          allLabel="Tất cả đơn vị"
          initialOptions={
            value.unitId && value.unitName
              ? [{ value: value.unitId, label: value.unitName }]
              : []
          }
          loadOptions={async ({ page, signal, searchText }) => {
            const res = await fetchUnits(
              page,
              10,
              { keySearch: searchText?.trim() || undefined },
              signal,
            )
            const arr = Array.isArray(res.items) ? res.items : []
            const pageSize = 10
            const hasNextPage = arr.length >= pageSize

            return {
              options: arr.map((u: any) => ({
                value: u.id,
                label: u.name,
              })),
              hasNextPage,
              nextPage: hasNextPage ? page + 1 : undefined,
            }
          }}
          onLazyValueChange={(unitId, option) => {
            onChange({
              ...value,
              unitId: unitId,
              unitName: option?.label ?? undefined,
            })
          }}
        />
      ) : null}
      <DateRangePicker
        className="w-full sm:w-80 h-10"
        value={{
          from: parseToLocalDate(value.fromDate),
          to: parseToLocalDate(value.toDate),
        }}
        onChange={(range) =>
          onChange({
            ...value,
            fromDate: getStartOfDayISOString(range?.from),
            toDate: getEndOfDayISOString(range?.to),
          })
        }
      />
    </div>
  )
}
